import * as React from 'react'
import { Star } from 'react-feather'

import { Strong, Text } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'
import { LinkWithLeftPaddingSometimes, SpaceBetweenFlexSpan } from './Basics.styles'

const PRE = `${i18nKeyPrefix}-BASICS-NETWORK-RATING`

interface IProps {
  networkRating: number | null
}

export default function NetworkRating(props: IProps) {
  const { networkRating } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const eliLearnMoreLink = 'https://pages.wonderschool.com/early-learning-marketplace-pte'

  return (
    <Bullet icon={<Star />}>
      <SpaceBetweenFlexSpan>
        <Strong>{t(`${PRE}-TEXT`)}</Strong>
        <LinkWithLeftPaddingSometimes href={eliLearnMoreLink} target="_blank">
          {t(`${PRE}-MORE`)}
        </LinkWithLeftPaddingSometimes>
      </SpaceBetweenFlexSpan>
      <Text muted>
        {networkRating != null && networkRating >= 1
          ? t(`${PRE}-LEVEL`, { networkRating })
          : t(`${PRE}-NOT-PARTICIPATING`)}
      </Text>
    </Bullet>
  )
}
